export const FETCH_SCHEDULE = 'FETCH_SCHEDULE';

export const scheduleAction = (history) => ({
  type: FETCH_SCHEDULE,
  payload: history
});

